// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class ServiceDeactivateResource extends Resource {
    basePath: string = 'services/deactivate/';

    objectPath: string = 'services/deactivate/{ident}/';
}
